module.exports = __webpack_public_path__ + "14four/static/media/take_photo_button.dadd35f8.png";